// Copyright (c) Move Closer 2022.

import { Model } from '@movecloser/front-core'

import { CompanyData } from '../../../contexts/profile/contracts/company'

import { ICompany } from '../contracts/models'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export class Company extends Model<CompanyData> implements ICompany {
  protected boot (): void {
    this.initialValues = {}
    this.modelProperties = [
      'companyAdmin',
      'email',
      'id',
      'legalAddress',
      'legalName',
      'name',
      'vatTaxId'
    ]
  }
}
